'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LoginSignup = require('./LoginSignup.scss');

var _LoginSignup2 = _interopRequireDefault(_LoginSignup);

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _session = require('redux/modules/session');

var sessionActions = _interopRequireWildcard(_session);

var _validation = require('utils/validation');

var _SocialAuthen = require('components/Nav/SocialAuthen');

var _SocialAuthen2 = _interopRequireDefault(_SocialAuthen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Reset: {
    displayName: 'Reset'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/Reset.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Reset = _wrapComponent('Reset')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    resetPosted: state.session.resetPosted,
    messages: state.language.messages,
    user: state.session.user,
    pathname: state.routing.locationBeforeTransitions.pathname
  };
}, (0, _extends3.default)({ push: _reactRouterRedux.push }, sessionActions)), _dec2 = (0, _reactCssModules2.default)(_LoginSignup2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Reset, _Component);

  function Reset() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Reset);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Reset.__proto__ || (0, _getPrototypeOf2.default)(Reset)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      passwordError: false,
      passwordErrorTemplateId: '',
      passwordErrorTemplateValues: {},
      confirmPasswordError: false,
      confirmPasswordErrorTemplateId: '',
      confirmPasswordErrorTemplateValues: {}
    }, _this.onClose = function () {
      if (_this.props.isFromGuest) {
        _this.props.openSet(false);
      } else {
        _this.props.openReset(false);
      }
      // this.props.push(this.props.pathname);
      window.location.href = '/';
    }, _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.validatePassword()) {
        var password = _this.refs.password.value;
        var isFromGuest = _this.props.isFromGuest;

        var email = _this.props.user.email;
        var promise = void 0;
        if (isFromGuest) {
          promise = _this.props.sendForgot({ email: email, isFromGuest: isFromGuest });
        } else {
          var token = _this.props.token;

          promise = _promise2.default.resolve({ token: token });
        }
        promise.then(function (_ref2) {
          var token = _ref2.token;
          return _this.props.postReset(token, password);
        });
      }
    }, _this.validatePassword = function () {
      var password = _this.refs.password.value;
      var confirmPassword = _this.refs.confirmPassword.value;
      var data = {
        password: {
          value: password,
          required: true,
          format: 'password',
          label: _this.props.messages['reset.password.placeholder']
        }, confirmPassword: {
          value: confirmPassword,
          format: 'match-password',
          match: 'password',
          label: _this.props.messages['reset.confirm_password.placeholder']
        }
      };
      var validatedData = (0, _validation.validateForm)(data);
      (0, _keys2.default)(validatedData).map(function (field) {
        if (field === 'formError') return;
        _this.setState((0, _defineProperty3.default)({}, field + 'Error', validatedData[field].error));
        _this.setState((0, _defineProperty3.default)({}, field + 'ErrorTemplateId', validatedData[field].templateId));
        _this.setState((0, _defineProperty3.default)({}, field + 'ErrorTemplateValues', validatedData[field].templateValues));
      });
      if (validatedData.formError) {
        return false;
      }
      return true;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Reset, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          resetPosted = _props.resetPosted,
          messages = _props.messages,
          isFromGuest = _props.isFromGuest;
      var _state = this.state,
          passwordError = _state.passwordError,
          passwordErrorTemplateId = _state.passwordErrorTemplateId,
          passwordErrorTemplateValues = _state.passwordErrorTemplateValues;
      var _state2 = this.state,
          confirmPasswordError = _state2.confirmPasswordError,
          confirmPasswordErrorTemplateId = _state2.confirmPasswordErrorTemplateId,
          confirmPasswordErrorTemplateValues = _state2.confirmPasswordErrorTemplateValues;

      return _react3.default.createElement(
        'div',
        null,
        resetPosted ? _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'h1',
            null,
            isFromGuest ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'set.done.header' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'reset.done.header' })
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'subtitle' },
            isFromGuest ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'set.done.description' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'reset.done.description' })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'form' },
            _react3.default.createElement(
              'a',
              { styleName: 'btn-action', onClick: this.onClose },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'reset.done.close' })
            )
          )
        ) : _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'h1',
            null,
            isFromGuest ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'set.header' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'reset.header' })
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'subtitle' },
            isFromGuest ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'set.description' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'reset.description' })
          ),
          _react3.default.createElement(
            'form',
            { styleName: 'form', onSubmit: this.handleSubmit, style: { 'margin-bottom': '20px' } },
            _react3.default.createElement(
              'div',
              { styleName: 'input-container' },
              _react3.default.createElement('input', { styleName: passwordError ? 'custom-input-error' : 'custom-input', type: 'password', ref: 'password', placeholder: messages['reset.password.placeholder'] })
            ),
            passwordError && _react3.default.createElement(
              'p',
              { styleName: 'error' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: passwordErrorTemplateId, values: passwordErrorTemplateValues })
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'input-container' },
              _react3.default.createElement('input', { styleName: confirmPasswordError ? 'custom-input-error' : 'custom-input', type: 'password', ref: 'confirmPassword', placeholder: messages['reset.confirm_password.placeholder'] })
            ),
            confirmPasswordError && _react3.default.createElement(
              'p',
              { styleName: 'error' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: confirmPasswordErrorTemplateId, values: confirmPasswordErrorTemplateValues })
            ),
            _react3.default.createElement(
              'button',
              { type: 'submit', styleName: 'btn-action' },
              isFromGuest ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'set.reset_password' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'reset.reset_password' })
            )
          )
        ),
        isFromGuest && _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            'p',
            { styleName: 'or' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'login.or' })
          ),
          _react3.default.createElement(_SocialAuthen2.default, null)
        )
      );
    }
  }]);
  return Reset;
}(_react2.Component), _class2.propTypes = {
  resetPosted: _react2.PropTypes.bool,
  openReset: _react2.PropTypes.func,
  openSet: _react2.PropTypes.func,
  postReset: _react2.PropTypes.func,
  token: _react2.PropTypes.string,
  messages: _react2.PropTypes.object,
  push: _react2.PropTypes.func,
  sendForgot: _react2.PropTypes.func,
  isFromGuest: _react2.PropTypes.bool,
  user: _react2.PropTypes.object,
  pathname: _react2.PropTypes.string
}, _temp2)) || _class) || _class));

exports.default = Reset;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/Reset.js
// module id = 1570
// module chunks = 47